var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 189,
    viewBox: "0 0 188 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.5479 0.188934H89.457V187.912H98.5479V0.188934Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5479 0.188934H89.457V187.912H98.5479V0.188934Z",
    fill: "#CFFFD8",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188 89.5117H0V98.5892H188V89.5117Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188 89.5117H0V98.5892H188V89.5117Z",
    fill: "#CFFFD8",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7288 24.465L24.3008 30.8837L157.236 163.623L163.664 157.203L30.7288 24.465Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7288 24.465L24.3008 30.8837L157.236 163.623L163.664 157.203L30.7288 24.465Z",
    fill: "#CFFFD8",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.236 24.4633L24.3008 157.202L30.7288 163.62L163.664 30.882L157.236 24.4633Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.236 24.4633L24.3008 157.202L30.7288 163.62L163.664 30.882L157.236 24.4633Z",
    fill: "#CFFFD8",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68781 54.4632L5.25781 62.8698L179.365 133.698L182.795 125.291L8.68781 54.4632Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68781 54.4632L5.25781 62.8698L179.365 133.698L182.795 125.291L8.68781 54.4632Z",
    fill: "#CFFFD8",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.288 5.45233L54.3555 179.302L62.7745 182.727L133.707 8.87728L125.288 5.45233Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.288 5.45233L54.3555 179.302L62.7745 182.727L133.707 8.87728L125.288 5.45233Z",
    fill: "#CFFFD8",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.572 54.7791L5.16406 124.875L8.5586 133.296L182.966 63.2003L179.572 54.7791Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.572 54.7791L5.16406 124.875L8.5586 133.296L182.966 63.2003L179.572 54.7791Z",
    fill: "#CFFFD8",
    fillOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0665 5.34915L54.6328 8.73779L124.813 182.888L133.246 179.5L63.0665 5.34915Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0665 5.34915L54.6328 8.73779L124.813 182.888L133.246 179.5L63.0665 5.34915Z",
    fill: "#CFFFD8",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStar);
export default __webpack_public_path__ + "static/media/green-star.4409eb4c19f70aa43736dd81c2aa4f9d.svg";
export { ForwardRef as ReactComponent };